// https://www.npmjs.com/package/react-redux-i18n
export const defaultLanguage = 'vi';

export const listLanguage = {
  en: 'en',
  vi: 'vi',
};
